<template>
  <div id="principal">
    <menu-terceiros/>

    <div class="w3-padding-large w3-margin-top">
      <h2 class="titulo texto-vermelho w3-margin-bottom">Cotações</h2>
      <div v-if="!cotacao_selecionada" class="w3-margin-top w3-display-container w3-col s12">
        <button 
          class="w3-btn w3-theme w3-display-middle" 
          id="btCarregarCotacao" 
          @click="listarCotacoes">
          <b>Carregar cotação</b>
        </button>
      </div>

      <div 
        class="cotacao-selecionada w3-col"
        v-if="cotacao_selecionada && 
        !itens_processando"
        v-cloak>
        
        <header class="w3-col">
          <h5 class="w3-left  w3-col s12 m8 l9">
            <b>Cotação {{dados_cotacao_selecionada}}</b>
          </h5>
          <button 
            class="w3-button w3-theme w3-right w3-col s12 m4 l3"
            id="btGravar"
            @click="gravarCotacao">
            <i class="fas fa-database"/>
            <b>Gravar</b>
          </button>
        </header>
        
        <div class="w3-col s12 m4 l7 w3-margin-top">
          <b
            class="w3-left w3-col"
            style="color: #9c1d1c; text-decoration: underline; cursor: pointer;"
            @click="abrirModalPrazos">
            {{descricao_prazo}}
          </b>
        </div>
        
        <div class="w3-col  s12 m8 l5 w3-right" style="text-align: right" >
          <b class="w3-margin-right w3-col s12 m3 l2 paginacao">
            Página {{pagina_atual}} / {{quantidade_paginas}}
          </b>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1" 
            style="margin-left: 5px" 
            id="btPrimeira" 
            @click="primeiraPagina">
            <i class="fa fa-angle-double-left"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1" 
            style="margin-left: 5px" 
            id="btAnterior" 
            @click="paginaAnterior">
            <i class="fa fa-angle-left"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1"
            style="margin-left: 5px" 
            id="btProxima" 
            @click="proximaPagina">
            <i class="fa fa-angle-right"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1"
            style="margin-left: 5px" 
            id="btUltima" 
            @click="ultimaPagina">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>


        <div class="w3-col">
          <label class="w3-left titulo-small">Observação do fornecedor</label>
          <input
            type="text"
            maxlength="200"
            v-model="cotacao_selecionada.observacao"
            class="w3-block w3-margin-bottom">
        </div>
      </div>

      <div v-if="itens.length > 0" class="listagem">
        <div 
          v-for="(item, item_index) in itens" 
          :key="item_index" 
          class="w3-col" 
          v-cloak>
          <div
            class="w3-margin-bottom w3-col w3-padding"
            v-show="podeMostrarItem(item.item_id)"
            style="border: 1px solid #c6c6c6; border-radius: 4px">
            
            <div class="w3-col" style="color: #999999">
              <label class="w3-left titulo-small">Item:&nbsp;</label>
              <strong class="w3-left">{{item.item_id}}</strong>
            </div>

            <div class="w3-col">
              <strong class="w3-left w3-text-theme">{{item.produto_id}} - {{item.nome}}</strong>
            </div>

            <div 
              class="w3-col m9 s12" 
              v-if="cotacao_selecionada.visualizar_marca_cot_online==='S'">
              <label class="w3-left titulo-small">Marca:&nbsp;</label>
              <strong class="w3-left w3-text-theme">{{item.nome_marca}}</strong>
            </div>

            <div class="w3-col">
              <div class="w3-col m5 s12 l6">
                <label class="w3-left titulo-small">Quantidade:&nbsp;</label>
                <strong class="w3-left">{{item.quantidade}} {{getUnidade(item)}}</strong>
              </div>

              <div class="w3-col m5 s12 l6">
                <label 
                  class="w3-left titulo-small" 
                  v-if="item.codigo_original">Código original:&nbsp;
                </label>
                <strong 
                  class="w3-left"
                  v-if="item.codigo_original">
                  {{item.codigo_original}}
                </strong>
              </div>
            </div>

            <div class="w3-col m5 s12 l6">
              <label v-show="item.existe_vencedor == 'N'" class="w3-left titulo-small w3-col s6"> Preço ({{getUnidade(item)}}) à vista:&nbsp;</label>
              <label v-show="item.existe_vencedor == 'S'" style="text-decoration: line-through" class="w3-left titulo-small w3-col s6"> Preço ({{getUnidade(item)}}) à vista:&nbsp;</label>
              
              <input
                class="w3-col s6"
                type="number"
                v-model="item.preco_vista"
                min="0.000001"
                max="9999999999.999999"
                step=".000001"
                :disabled="item.existe_vencedor == 'S'"
                alt="Precisão considerada: até 6 casas decimais"
                title="Precisão considerada: até 6 casas decimais"
                v-on:blur="validarPreco(item, 'V')">
            </div>

            <div class="w3-col m5 s12 l6" v-if="tem_prazo">
              <label v-show="item.existe_vencedor == 'N'" class="w3-left titulo-small w3-col s6">Preço ({{getUnidade(item)}}) a prazo:&nbsp;</label>
              <label v-show="item.existe_vencedor == 'S'" style="text-decoration: line-through" class="w3-left titulo-small w3-col s6">Preço ({{getUnidade(item)}}) a prazo:&nbsp;</label>

              <input
                class="w3-col s6"
                type="number"
                v-model="item.preco_prazo"
                min="0.000001"
                max="9999999999.999999"
                step=".000001"
                :disabled="item.existe_vencedor == 'S'"
                alt="Precisão considerada: até 6 casas decimais"
                title="Precisão considerada: até 6 casas decimais"
                v-on:blur="validarPreco(item, 'P')">
            </div>
          </div>
        </div>
      </div>

      <div 
        class="w3-col w3-margin-bottom cotacao-selecionada" 
        v-if="cotacao_selecionada && 
        !itens_processando"
        v-cloak>

        <button 
          class="w3-col w3-btn w3-theme m4 s12"
          id="btGravar2"
          @click="gravarCotacao">
          <i class="fas fa-database"/>
          <b> Gravar</b>
        </button>
        
        <div 
          class="w3-col  s12 m8 l5 w3-right w3-margin-top"
          style="text-align: right">
          <b class="w3-margin-right w3-col s12 m3 l2 paginacao">Página {{pagina_atual}} / {{quantidade_paginas}}</b>
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1"
            style="margin-left: 5px" 
            id="btPrimeira2" 
            @click="primeiraPagina">
            <i class="fa fa-angle-double-left"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1" 
            style="margin-left: 5px" 
            id="btAnterior2"
            @click="paginaAnterior">
            <i class="fa fa-angle-left"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1"
            style="margin-left: 5px"
            id="btProxima2"
            @click="proximaPagina">
            <i class="fa fa-angle-right"></i>
          </button>
          
          <button 
            class="w3-btn w3-theme w3-button w3-col s2 m2 l1"
            style="margin-left: 5px"
            id="btUltima2" 
            @click="ultimaPagina">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>

      <div id="modalCotacoes" class="w3-modal">
        <div class="w3-modal-content w3-padding-large w3-animate-zoom w3-padding">
          <header>
            <span 
              @click="fecharModalCotacoes" 
              class="w3-button w3-display-topright">
              &times;
            </span>
            <h4 class="texto-vermelho titulo">Selecione a cotação</h4>
          </header>

          <div style="cursor: pointer" class="w3-margin-bottom">
            <table class="w3-table-all w3-hide-small w3-hide-medium">
              <thead>
                <tr>
                  <th>Cotação</th>
                  <th>Data de cadastro</th>
                  <th>Comprador</th>
                  <th>CNPJ</th>
                  <th>Cidade</th>
                  <th style="color:#9c1d1c;">Validade</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(cotacao, cotacao_index) in lista_cotacoes"
                  :key="cotacao_index"
                  class="buscarClasseListaCotacoes"
                  @click="carregarCotacao(cotacao)"
                  style="cursor: pointer"
                  v-cloak>
                  <td>{{cotacao.cotacao_id}}</td>
                  <td>{{cotacao.data_cadastro}}</td>
                  <td>{{cotacao.nome_usuario_insercao}}</td>
                  <td>{{cotacao.cnpj_empresa_cotacao}}</td>
                  <td>{{cotacao.cidade_empresa_cotacao}}</td>
                  <td style="color:#9c1d1c;">{{cotacao.data_validade}}</td>
                </tr>              
              </tbody>
            </table>

            <div class="w3-hide-large w3-row-padding" style="padding:0">
              <div  
                v-for="(cotacao, cotacao_index) in lista_cotacoes"
                :key="cotacao_index"
                class="w3-col"
                style="border-bottom: 2px solid #bbbbbb;" 
                @click="carregarCotacao(cotacao)"
                v-cloak>
                
                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Cotação:&nbsp;</label>
                  <strong class="w3-left">{{cotacao.cotacao_id}}</strong>
                </div>

                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Data de cadastro:&nbsp;</label>
                  <strong class="w3-left">{{cotacao.data_cadastro}}</strong>
                </div>

                <div class="w3-col s12">
                  <label class="w3-left titulo-small">Comprador:&nbsp;</label>
                  <strong class="w3-left">{{cotacao.nome_usuario_insercao}}</strong>
                </div>

                <div class="w3-col s12" style="color:#9c1d1c;">
                  <label class="w3-left titulo-small">Validade:&nbsp;</label>
                  <strong class="w3-left">{{cotacao.data_validade}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div 
        id="modalPrazos" 
        class="w3-modal" 
        v-if="cotacao_selecionada">
        <div class="w3-modal-content w3-animate-zoom w3-padding-large">
          <header>
            <span 
              @click="fecharModalPrazos" 
              class="w3-button w3-display-topright">
              &times;
            </span>
            <h4 class="texto-vermelho titulo">Defina os prazos (dias)</h4>
          </header>

          <div class="w3-row-padding w3-margin-top w3-margin-bottom" style="padding:0">
            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 1&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_1"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 2&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_2"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 3&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_3"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 4&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_4"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 5&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_5"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 6&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_6"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 7&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_7"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 8&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_8"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 9&nbsp;</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_9"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 10</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_10"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 11</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_11"
                v-on:blur="validarPrazos">
            </div>

            <div class="w3-col s6 m3 w3-margin-bottom"  style="padding:0">
              <label class="w3-left titulo-small">Prazo 12</label>
              <br>
              <input
                type="number"
                min="0"
                max="9999"
                v-model="cotacao_selecionada.prazo_12"
                v-on:blur="validarPrazos">
            </div>
          </div>
        </div>
      </div>
      <div id="carregar_rodape"></div>
    </div>
  </div>
</template>

<script>
import VueNumeric from "vue-numeric";
import Biblioteca from '@/components/Repositorio/Biblioteca'
import MenuTerceiros from "@/components/MenuTerceiros";
import RCotacao from "@/components/Rest/RCotacao.js";

export default {
  name: "CotacoesFornecedores",
  components: {
    VueNumeric,
    MenuTerceiros
  },
  data() {
    return {
      api: process.env.API,
      cotacao_selecionada: undefined,
      lista_cotacoes: [],
      itens: {},
      classe_grid_cotacoes: "",
      pagina_atual: 0,
      quantidade_paginas: 0,
      quantidade_por_pagina: 20,
      descricao_prazo: "",
      tem_prazo: false,
      dados_cotacao_selecionada: "",
      cotacoes_processando: false,
      itens_processando: false
    };
  },
  mounted: function() {
    this.listarCotacoes();
  },
  methods: {
    precosParaServidor: function(preco) {
      if (!this.itens){
        return;
      }

      for (let i = 0; i < this.itens.length; i++) {
        this.itens[i].preco_vista = nPadrao(Biblioteca.valor(this.itens[i].preco_vista), 6);
        this.itens[i].preco_prazo = nPadrao(Biblioteca.valor(this.itens[i].preco_prazo), 6);
      }
    },
    
    precosParaTela: function(preco) {
      if (!this.itens){
        return;
      }

      for (let i = 0; i < this.itens.length; i++) {
        this.itens[i].preco_vista = Biblioteca.valor(this.itens[i].preco_vista);
        this.itens[i].preco_prazo = Biblioteca.valor(this.itens[i].preco_prazo);
      }
    },
    
    async listarCotacoes(data) {
      this.cotacoes_processando = true;
    
      try {
        let retorno = await RCotacao.buscarListaCotacao(this.axios);
        
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        this.lista_cotacoes = JSON.parse(JSON.stringify(retorno.dados));
        this.cotacoes_processando = false;
        this.abrirModalCotacoes();
      } catch (e) {
        this.cotacoes_processando = false;
        Biblioteca.exclamar(e.message);
      }
    },
    
    carregarCotacao: function(cotacao) {
      this.cotacao_selecionada = cotacao;
      this.dados_cotacao_selecionada = cotacao.cotacao_id + " - Válida até: " + cotacao.data_validade;

      this.definirPrazo();
      this.fecharModalCotacoes();
      this.buscarItensCotacao(cotacao.cotacao_id);
    },
    
    async buscarItensCotacao(cotacao_buscar_id) {
      this.itens_processando = true;
      let parametros = {
        cotacao_id: cotacao_buscar_id
      };
        
      try {
        let retorno = await RCotacao.buscarItensCotacao(this.axios, parametros);
        
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }
        
        this.itens_processando = false;
        this.itens = JSON.parse(JSON.stringify(retorno.dados));
        this.precosParaTela();
        this.ajustarPaginacao();
      } catch (e) {
        this.îtens_processando = false;
        Biblioteca.exclamar(e.message);
      }
    },
    
    ajustarPaginacao: function() {
      this.pagina_atual = 1;

      if (this.itens.length < this.quantidade_por_pagina) {
        this.quantidade_paginas = 1;
      } else {
        this.quantidade_paginas = Math.trunc(
          this.itens.length / this.quantidade_por_pagina
        );

        if (this.itens.length % this.quantidade_por_pagina > 0) {
          this.quantidade_paginas += 1;
        }
      }
    },
    
    podeMostrarItem: function(item_id) {
      let item_final = this.pagina_atual * this.quantidade_por_pagina;
      let item_inicial = item_final - this.quantidade_por_pagina + 1;

      return item_id >= item_inicial && item_id <= item_final;
    },
    
    primeiraPagina: function() {
      this.pagina_atual = 1;
    },
    
    paginaAnterior: function() {
      if (this.pagina_atual > 1) {
        this.pagina_atual -= 1;
      }
    },
    
    proximaPagina: function() {
      if (this.pagina_atual < this.quantidade_paginas) {
        this.pagina_atual += 1;
      }
    },
    
    ultimaPagina: function() {
      this.pagina_atual = this.quantidade_paginas;
    },
    
    abrirModalCotacoes: function() {
      this.cotacoes_processando = true;
      $("#modalCotacoes")
        .removeAttr("style")
        .show();
    },
    
    fecharModalCotacoes: function() {
      $("#modalCotacoes").hide();
    },
    
    abrirModalPrazos: function() {
      $("#modalPrazos")
        .removeAttr("style")
        .show();
    },
    
    fecharModalPrazos: function() {
      $("#modalPrazos").hide();
      this.definirPrazo();
    },
    
    getCotacaoSelecionada: function() {
      if (cotacao_selecionada) {
        return " - " + cotacao_selecionada.cotacao_id;
      } else {
        return "";
      }
    },
    
    async gravarCotacao() {
      try {
        this.precosParaServidor(); 
        
        let parametros = {
          cotacao_id: this.cotacao_selecionada.cotacao_id,
          prazo_1: this.cotacao_selecionada.prazo_1,
          prazo_2: this.cotacao_selecionada.prazo_2,
          prazo_3: this.cotacao_selecionada.prazo_3,
          prazo_4: this.cotacao_selecionada.prazo_4,
          prazo_5: this.cotacao_selecionada.prazo_5,
          prazo_6: this.cotacao_selecionada.prazo_6,
          prazo_7: this.cotacao_selecionada.prazo_7,
          prazo_8: this.cotacao_selecionada.prazo_8,
          prazo_9: this.cotacao_selecionada.prazo_9,
          prazo_10: this.cotacao_selecionada.prazo_10,
          prazo_11: this.cotacao_selecionada.prazo_11,
          prazo_12: this.cotacao_selecionada.prazo_12,
          observacao: this.cotacao_selecionada.observacao,
          itens: this.itens
        }
  
        let retorno =  await RCotacao.atualizarCotacao(this.axios, parametros);
        if (retorno.houve_erro == 'S') {
          throw new Error(retorno.mensagem);
        }
        
        this.precosParaTela();
        Biblioteca.informar('Gravação realizada com sucesso.');
      } 
      catch (e) {
        this.precosParaTela();
        Biblioteca.exclamar(e.message);
      }    
    },
    
    definirPrazo() {
      this.tem_prazo =
        this.cotacao_selecionada.prazo_1 > 0 ||
        this.cotacao_selecionada.prazo_2 > 0 ||
        this.cotacao_selecionada.prazo_3 > 0 ||
        this.cotacao_selecionada.prazo_4 > 0 ||
        this.cotacao_selecionada.prazo_5 > 0 ||
        this.cotacao_selecionada.prazo_6 > 0 ||
        this.cotacao_selecionada.prazo_7 > 0 ||
        this.cotacao_selecionada.prazo_8 > 0 ||
        this.cotacao_selecionada.prazo_9 > 0 ||
        this.cotacao_selecionada.prazo_10 > 0 ||
        this.cotacao_selecionada.prazo_11 > 0 ||
        this.cotacao_selecionada.prazo_12 > 0;

      if (!this.tem_prazo) {
        this.descricao_prazo = "À Vista";
      } else {
        this.descricao_prazo = "Prazo: " + this.cotacao_selecionada.prazo_1;

        if (this.cotacao_selecionada.prazo_2 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_2;
        }

        if (this.cotacao_selecionada.prazo_3 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_3;
        }

        if (this.cotacao_selecionada.prazo_4 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_4;
        }

        if (this.cotacao_selecionada.prazo_5 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_5;
        }

        if (this.cotacao_selecionada.prazo_6 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_6;
        }

        if (this.cotacao_selecionada.prazo_7 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_7;
        }

        if (this.cotacao_selecionada.prazo_8 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_8;
        }

        if (this.cotacao_selecionada.prazo_9 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_9;
        }

        if (this.cotacao_selecionada.prazo_10 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_10;
        }

        if (this.cotacao_selecionada.prazo_11 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_11;
        }

        if (this.cotacao_selecionada.prazo_12 > 0) {
          this.descricao_prazo += " / " + this.cotacao_selecionada.prazo_12;
        }

        this.descricao_prazo += " dias";
      }
    },
    
    validarPreco(item, tipo) {
      if (tipo == "V") {
        if (item.preco_vista == 0) {
          item.preco_vista = 0;
        } else {
          item.preco_vista = Biblioteca.valor(item.preco_vista);
          item.preco_vista = item.preco_vista.toFixed(6);	  
          if (item.preco_vista > 9999999999.99) {
            item.preco_vista = 0;
          }
        }
      } else if (tipo == "P") {
        if (item.preco_prazo == 0) {
          item.preco_prazo = 0;
        } else {
          item.preco_prazo = Biblioteca.valor(item.preco_prazo);
          item.preco_prazo = item.preco_prazo.toFixed(6);
          if (item.preco_prazo > 9999999999.99) {
            item.preco_prazo = 0;
          }
        }
      }
    },
    
    validarPrazos() {
      if (
        this.cotacao_selecionada.prazo_1 == 0 ||
        this.cotacao_selecionada.prazo_1 > 9999
      ) {
        this.cotacao_selecionada.prazo_1 = 0;
      } else {
        this.cotacao_selecionada.prazo_1 = Math.trunc(
          this.cotacao_selecionada.prazo_1
        );
      }

      if (
        this.cotacao_selecionada.prazo_2 == 0 ||
        this.cotacao_selecionada.prazo_2 > 9999
      ) {
        this.cotacao_selecionada.prazo_2 = 0;
      } else {
        this.cotacao_selecionada.prazo_2 = Math.trunc(
          this.cotacao_selecionada.prazo_2
        );
      }

      if (
        this.cotacao_selecionada.prazo_3 == 0 ||
        this.cotacao_selecionada.prazo_3 > 9999
      ) {
        this.cotacao_selecionada.prazo_3 = 0;
      } else {
        this.cotacao_selecionada.prazo_3 = Math.trunc(
          this.cotacao_selecionada.prazo_3
        );
      }

      if (
        this.cotacao_selecionada.prazo_4 == 0 ||
        this.cotacao_selecionada.prazo_4 > 9999
      ) {
        this.cotacao_selecionada.prazo_4 = 0;
      } else {
        this.cotacao_selecionada.prazo_4 = Math.trunc(
          this.cotacao_selecionada.prazo_4
        );
      }

      if (
        this.cotacao_selecionada.prazo_5 == 0 ||
        this.cotacao_selecionada.prazo_5 > 9999
      ) {
        this.cotacao_selecionada.prazo_5 = 0;
      } else {
        this.cotacao_selecionada.prazo_5 = Math.trunc(
          this.cotacao_selecionada.prazo_5
        );
      }

      if (
        this.cotacao_selecionada.prazo_6 == 0 ||
        this.cotacao_selecionada.prazo_6 > 9999
      ) {
        this.cotacao_selecionada.prazo_6 = 0;
      } else {
        this.cotacao_selecionada.prazo_6 = Math.trunc(
          this.cotacao_selecionada.prazo_6
        );
      }

      if (
        this.cotacao_selecionada.prazo_7 == 0 ||
        this.cotacao_selecionada.prazo_7 > 9999
      ) {
        this.cotacao_selecionada.prazo_7 = 0;
      } else {
        this.cotacao_selecionada.prazo_7 = Math.trunc(
          this.cotacao_selecionada.prazo_7
        );
      }

      if (
        this.cotacao_selecionada.prazo_8 == 0 ||
        this.cotacao_selecionada.prazo_8 > 9999
      ) {
        this.cotacao_selecionada.prazo_8 = 0;
      } else {
        this.cotacao_selecionada.prazo_8 = Math.trunc(
          this.cotacao_selecionada.prazo_8
        );
      }

      if (
        this.cotacao_selecionada.prazo_9 == 0 ||
        this.cotacao_selecionada.prazo_9 > 9999
      ) {
        this.cotacao_selecionada.prazo_9 = 0;
      } else {
        this.cotacao_selecionada.prazo_9 = Math.trunc(
          this.cotacao_selecionada.prazo_9
        );
      }

      if (
        this.cotacao_selecionada.prazo_10 == 0 ||
        this.cotacao_selecionada.prazo_10 > 9999
      ) {
        this.cotacao_selecionada.prazo_10 = 0;
      } else {
        this.cotacao_selecionada.prazo_10 = Math.trunc(
          this.cotacao_selecionada.prazo_10
        );
      }

      if (
        this.cotacao_selecionada.prazo_11 == 0 ||
        this.cotacao_selecionada.prazo_11 > 9999
      ) {
        this.cotacao_selecionada.prazo_11 = 0;
      } else {
        this.cotacao_selecionada.prazo_11 = Math.trunc(
          this.cotacao_selecionada.prazo_11
        );
      }

      if (
        this.cotacao_selecionada.prazo_12 == 0 ||
        this.cotacao_selecionada.prazo_12 > 9999
      ) {
        this.cotacao_selecionada.prazo_12 = 0;
      } else {
        this.cotacao_selecionada.prazo_12 = Math.trunc(
          this.cotacao_selecionada.prazo_12
        );
      }
    },
    getUnidade(item){
     let embalagemFracionada = parseFloat(item.embalagem_fracionada);
      if(embalagemFracionada != 1)
        return item.unidade_compra;
      return item.unidade;
    }
  }
}
</script>

<style scoped>
  input[type=number]{
    border:none;
    border-bottom: 2px solid #cccccc
  }
  
  @media screen and (max-width: 767px){
    .cotacao-selecionada > div{
      text-align: center !important;
      margin-bottom:25px;
    }
    
    @media screen and (max-width: 500px){
      .cotacao-selecionada button:not(#btGravar):not(#btGravar2){
        margin:0 calc((100% - 67%)/8) !important;
      }
    }
    
    @media screen and (min-width: 500px){
      .cotacao-selecionada .paginacao{
        width: calc(100% - (66.66664% + 36px));
      }
    }
      .item strong, .item input{
        float:right !important;
    }
  }

  @media screen and (min-width: 768px){    
    .paginacao{
      line-height:38px;
    }
    
    @media screen and (min-width: 1024px) and (max-width: 1199px){
      .cotacao-selecionada button.l1{
        width: 10%;
      }
      .cotacao-selecionada .paginacao{
        width: calc(100% - (40% + 36px));
      }
    }
  }
  
  @media screen and (min-width: 1200px){
    .item {
      width: calc(50% - 10px) !important;
      margin: 5px !important; 
    }
    
    .listagem{
      width: calc(100% + 10px);
      margin:0 -5px
    }
    
    .cotacao-selecionada .paginacao{
      width: calc(100% - (33.3332% + 36px));
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/CotacoesFornecedores.vue